// Module
var code = "<common-questions *ngIf=\"!isNewFaqEnabled\"></common-questions> <faqs *ngIf=\"isNewFaqEnabled\"></faqs> ";
// Exports
module.exports = code;